import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { PageContentPreloader, NoItemsPanel, SearchPanel, TransfersTable } from 'common/components';
import noPaymentsImage from 'common/images/noPayments.svg';

import { getCrmFinancesTransfers } from '../../_redux';

const CRMTransfersTab = ({ transfers, transfersAreLoaded, getCrmFinancesTransfers, location, history, intl }) => {
  const parsedSearch = useMemo(() => queryString.parse(location.search), [location.search]);
  const { tab, ...restSearch } = parsedSearch;
  const query = useMemo(() => ({ page_size: 10, ...restSearch }), [location.search]);

  useEffect(() => {
    if (tab !== 'internalTransfers') return;
    getCrmFinancesTransfers({ search: query });
  }, [getCrmFinancesTransfers, location.search]);

  const filters = [
    {
      title: 'justStatus',
      accessor: 'status',
      options: [
        { value: '', label: intl.formatMessage({ id: 'justAll' }) },
        { value: 'IN_PROGRESS', label: intl.formatMessage({ id: 'status_in_progress' }) },
        { value: 'WAITING_FOR_APPROVAL', label: intl.formatMessage({ id: 'status_waiting_for_approval' }) },
        { value: 'COMPLETED', label: intl.formatMessage({ id: 'status_completed' }) },
        { value: 'CANCELED', label: intl.formatMessage({ id: 'status_canceled' }) },
      ],
    },
    {
      title: 'boTransferType',
      accessor: 'transferType',
      options: [
        { value: '', label: intl.formatMessage({ id: 'justAll' }) },
        { value: 'INNER', label: intl.formatMessage({ id: 'boInnerTransfer' }) },
        { value: 'FROM_WALLET', label: intl.formatMessage({ id: 'fromWallet' }) },
        { value: 'TO_TRADER_WALLET', label: intl.formatMessage({ id: 'toTraderWallet' }) },
      ],
    },
  ];

  return (
    <PageContentPreloader ready={transfersAreLoaded} type="smallLines" firstLaunchOnly>
      <SearchPanel
        location={location}
        history={history}
        getList={data => getCrmFinancesTransfers({ search: data.search })}
        filters={filters}
        params={{ search: query }}
      />
      {transfers.count ? (
        <TransfersTable
          pageLink="backoffice/transfers"
          data={transfers}
          loading={!transfersAreLoaded}
          location={location}
          history={history}
          getList={data => getCrmFinancesTransfers({ search: data.search })}
          onRowClick={() => {}}
          params={{ search: query }}
          hasPaymentOperationManagers={false}
          disableLinks
          noResponsive
        />
      ) : (
        <NoItemsPanel
          icon={noPaymentsImage}
          captionSlug={Object.keys(query).length ? 'noTransfersMatchingTheParameters' : 'noInternalTransfers'}
        />
      )}
    </PageContentPreloader>
  );
};

CRMTransfersTab.propTypes = {
  transfers: PropTypes.object.isRequired,
  transfersAreLoaded: PropTypes.bool.isRequired,
  getCrmFinancesTransfers: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default compose(
  injectIntl,
  withRouter,
  connect(
    state => ({
      transfers: state.crm.finances.transfers,
      transfersAreLoaded: state.crm.finances.transfersAreLoaded,
    }),
    {
      getCrmFinancesTransfers: search => getCrmFinancesTransfers.request(search),
    }
  )
)(CRMTransfersTab);
